import { render, staticRenderFns } from "./Historical.vue?vue&type=template&id=47e759d4&scoped=true&"
import script from "./Historical.vue?vue&type=script&lang=js&"
export * from "./Historical.vue?vue&type=script&lang=js&"
import style0 from "./Historical.vue?vue&type=style&index=0&id=47e759d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e759d4",
  null
  
)

export default component.exports